<div class="row p-2 mb-3 align-items-center">
  <div class="col-12 col-md-7 text-start">
    <div class="page-title-heading">
      <div class="page-title-icon"><i class="fa-solid fa-credit-card"></i></div>
      <div>
        Méthodes de paiement
        <div class="page-title-subheading">Moyens de paiement acceptés par l'établissement et leurs clés d'intégration</div>
      </div>
    </div>
  </div>
  <div class="col-12 col-md-5 text-end">
    <app-header></app-header>
  </div>
</div>
   <div class="row">
    <div class="col-lg-12">
        <div class="card">
          
            <div class="card-body">
                  <div class="d-flex justify-content-between mb-5">
                    <div class="me-2">
                        <button *ngIf="buttonsPermission?.add" type="button" class="btn btn-danger btn-sm" (click)="add(addContent)">
                            <i class="fa-solid fa-plus me-2" aria-hidden="true"></i>Nouvelle méthode
                            </button>
                    </div>
                    <!-- Actions portant sur la ligne selectionnee : masquees tant qu'aucune
                         ligne ne l'est. Le bouton d'ajout, lui, reste toujours visible. -->
                    <div *ngIf="buttonsPermission && selected_data">
                        <button *ngIf="selected_data && buttonsPermission.show" (click)="show(showContent)" type="button"
                                class="btn btn-outline-primary btn-sm me-2" title="Voir le détail de la méthode sélectionnée">
                            <i class="fa-solid fa-eye me-1" aria-hidden="true"></i>Consulter
                        </button>
                        <button *ngIf="selected_data && buttonsPermission.edit" (click)="edit(editContent)" type="button"
                                class="btn btn-outline-warning btn-sm me-2" title="Modifier la méthode sélectionnée">
                            <i class="fa-solid fa-pen me-1" aria-hidden="true"></i>Modifier
                        </button>
                        <button *ngIf="selected_data && buttonsPermission.delete" (click)="delete()" type="button"
                                class="btn btn-outline-danger btn-sm me-2" title="Supprimer la méthode sélectionnée">
                            <i class="fa-solid fa-trash me-1" aria-hidden="true"></i>Supprimer
                        </button>
                        <button *ngIf="buttonsPermission.status && is_active!=null && !is_active" (click)="setStatus(1)" type="button"
                                class="btn btn-outline-success btn-sm me-2" title="Rendre cette méthode disponible au paiement">
                            <i class="fa-solid fa-circle-check me-1" aria-hidden="true"></i>Activer
                        </button>
                        <button *ngIf="buttonsPermission.status && is_active!=null && is_active" (click)="setStatus(0)" type="button"
                                class="btn btn-outline-secondary btn-sm me-2" title="Retirer cette méthode des paiements">
                            <i class="fa-solid fa-circle-minus me-1" aria-hidden="true"></i>Désactiver
                        </button>
                    </div>
                    <div class="form-group ms-auto">
                        <label for="search_text" class="form-label mb-0"><strong>Rechercher</strong></label>
                        <input id="search_text" type="text" name="search_text" class="form-control form-control-sm"
                               placeholder="Libellé ou slug" [(ngModel)]="search_text">
                    </div>
                </div>

                        <p>{{data!.length}} élément(s)</p>
                        <div class="table-responsive">
                        <table class="table" >
                            <thead class="">
                                <tr>
                                    <th style="width: 10px;">#</th>
                                    <th>Libellé</th>
                                    <th>Slug</th>
                                    <th>Clé publique</th>
                                    <th>Clé privée</th>
                                    <th>Clé secrète</th>
                                    <th>Statut</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr (click)="checked(d)" [class.table-active]="selected_data?.id === d.id" style="cursor: pointer;" *ngFor="let d of data | sampleSearch:search_text:'payment_methods' | paginate: {
                                id:'ngxP1',
                                itemsPerPage: pg.pageSize,
                                currentPage: pg.p,
                                totalItems: pg.total } ">
                                    <td>
                                        <div class="form-check mb-2">
                                            <input (click)="checked(d)" class="form-check-input" type="radio" [checked]="selected_data?.id === d.id" name="flexRadioDefault">
                                        
                                        </div>
                                    </td>
                                    <td>{{d.name}}</td>
                                    <td>{{d.slug}}</td>
                                    <td>{{d.public_key}}</td>
                                    <td>{{d.private_key}}</td>
                                    <td>{{d.secret_key}}</td>
                                    <td>
                                        <span *ngIf="d.is_active" class="badge bg-success">Actif</span>
                                        <span *ngIf="!d.is_active" class="badge bg-danger">Bloqué</span>

                                    </td>
                                </tr>
                            
                            </tbody>
                        </table>
                        </div>
                          <pagination-controls 
                        id="ngxP1"
                        (pageChange)="getPage($event)"
                      [maxSize]="9"
                      [directionLinks]="true"
                      [autoHide]="true"
                      [responsive]="true"
                      [previousLabel]="'Précédent'"
                      [nextLabel]="'Suivant'"
                      [screenReaderPaginationLabel]="'Pagination'"
                      [screenReaderPageLabel]="'page'"
                      [screenReaderCurrentLabel]="'Vous êtes sur la page'">
                     </pagination-controls>

            </div><!-- end card -->
        </div>
        <!-- end col -->
    </div>
    <!-- end col -->
</div>


<ng-template #addContent let-c="close" let-d="dismiss">
    <form #addForm="ngForm" (ngSubmit)="store(addForm.value)">
    <div class="modal-header">
      <h6 class="modal-title" id="modal-basic-title">Enregistrer une méthode de paiement</h6>
      <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')"></button>
    </div>
    <div class="modal-body" >
        <div class="row mb-3" >
      
            <div class=" form-group col-12 mb-3">
                <label for="">Libellé <span class="text-danger ml-2">(*)</span></label>
                <input type="text" name="name" class="form-control" ngModel>
            </div>
            <div class=" form-group col-12 mb-3">
                <label for="">Slug <span class="text-danger ml-2">(*)</span></label>
                <select name="name" class="form-control" ngModel>
                    <option *ngFor="let s of slugs" [value]="s">{{s}}</option>
                </select>
            </div>
            <div class=" form-group col-12 mb-3">
                <label for="">Clé publique </label>
                <input type="text" name="public_key" class="form-control" ngModel>
            </div>
            <div class=" form-group col-12 mb-3">
                <label for="">Clé privée </label>
                <input type="text" name="private_key" class="form-control" ngModel>
            </div>
            <div class=" form-group col-12 mb-3">
                <label for="">Clé secrète </label>
                <input type="text" name="secret_key" class="form-control" ngModel>
            </div>
            
         
        </div>
       
    </div>
    <div class="modal-footer">
      <button type="submit" class="btn btn-outline-dark" [disabled]="addForm.invalid"  >Enregistrer <app-loading [isVisible]="loading"></app-loading></button>
    </div>
</form>
  </ng-template>

  <ng-template #editContent let-c="close" let-d="dismiss">
    <form #editForm="ngForm" (ngSubmit)="update(editForm.value)">
    <div class="modal-header">
      <h6 class="modal-title" id="modal-basic-title">Modifier une méthode de paiement</h6>
      <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')"></button>
    </div>
    <div class="modal-body" >
        <div class="row mb-3" >
      
            <div class=" form-group col-12 mb-3">
                <label for="">Libellé <span class="text-danger ml-2">(*)</span></label>
                <input type="text" name="name" class="form-control" [(ngModel)]="selected_data.name">
            </div>
            <div class=" form-group col-12 mb-3">
                <label for="">Slug <span class="text-danger ml-2">(*)</span></label>
                <select name="slug" class="form-control" [(ngModel)]="selected_data.slug">
                    <option *ngFor="let s of slugs" [value]="s">{{s}}</option>
                </select>
            </div>
            <div class=" form-group col-12 mb-3">
                <label for="">Clé publique</label>
                <input type="text" name="public_key" class="form-control" [(ngModel)]="selected_data.public_key">
            </div>
            <div class=" form-group col-12 mb-3">
                <label for="">Clé privée </label>
                <input type="text" name="private_key" class="form-control" [(ngModel)]="selected_data.private_key">
            </div>
            <div class=" form-group col-12 mb-3">
                <label for="">Clé secrète</label>
                <input type="text" name="secret_key" class="form-control" [(ngModel)]="selected_data.secret_key">
            </div>
            
         
        </div>
       
    </div>
    <div class="modal-footer">
      <button type="submit" class="btn btn-outline-dark" [disabled]="editForm.invalid" >Sauvegarder <app-loading [isVisible]="loading"></app-loading></button>
    </div>
</form>
  </ng-template>

  <ng-template #showContent let-c="close" let-d="dismiss">
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">Détails des informations</h4>
        <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')"></button>
      </div>

      <div class="modal-body">
        <div class="table-responsive table-card">
            <table class="table table-borderless align-middle mb-0">
                <tbody>
                 
                </tbody>
            </table>
        </div>
      </div>
</ng-template>
